module.exports = __webpack_public_path__ + "resources/icon_94_shangjia.98fe9f04e986c023.png";


//////////////////
// WEBPACK FOOTER
// ../src/component/post-manage/manage-dialog/img/icon_94_shangjia.png
// module id = 613
// module chunks = 0 1 2 3